import {type ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import {type InterestRecommendation} from '@dms/api/interest-recommendations';
import i18n from '@dms/i18n';

export function getRecommendationChannel(channel: InterestRecommendation['recommendedChannel']) {
  const action = match(channel.channel)
    .returnType<{icon: ThemeIconKey; label: string}>()
    .with('call', () => ({
      icon: 'communication/call',
      label: i18n.t('general.actions.call', {defaultValue: 'Call'}),
    }))
    .with('email', () => ({
      icon: 'communication/email',
      label: i18n.t('entity.interestRecommendations.actions.email', {
        defaultValue: 'Reply by email',
      }),
    }))
    .with('sms', () => ({
      icon: 'communication/textsms',
      label: i18n.t('general.actions.sendSms', {defaultValue: 'Send SMS'}),
    }))
    .with('message', () => ({
      icon: 'communication/chat',
      label: i18n.t('entity.interestRecommendations.actions.message', {
        defaultValue: 'Reply to message',
      }),
    }))
    .exhaustive();

  const reason = match(channel.reasonCode)
    .with('lastInboundChannel', () =>
      i18n.t('entity.interestRecommendations.channelReasons.lastInboundChannel', {
        defaultValue: 'Use the channel of the customer’s latest contact',
      })
    )
    .with('noInboundContact', () =>
      i18n.t('entity.interestRecommendations.channelReasons.noInboundContact', {
        defaultValue: 'No incoming contact yet',
      })
    )
    .with('differentChannelAfterSilence', () =>
      i18n.t('entity.interestRecommendations.channelReasons.differentChannelAfterSilence', {
        defaultValue: 'No reply — try another channel',
      })
    )
    .exhaustive();

  return {...action, reason};
}
